// Mock transcription API service
class TranscriptionAPI {
  async transcribeAudio(audioBlob) {
    // Mock transcription - in real implementation this would call an actual transcription service
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve("This is a mock transcription of the audio recording.");
      }, 1000);
    });
  }
}

export default new TranscriptionAPI();
